import { Component, Host, State, h } from '@stencil/core';
import { loadingBarService, LoadingBarStatus } from '../../utils/services/loadingBarService';


@Component({
  tag: 'aico-store-locator-loading-bar',
  styleUrl: 'aico-store-locator-loading-bar.css',
  shadow: true,
})
export class AicoStoreLocatorLoadingBar {
  @State() status: LoadingBarStatus = loadingBarService.getStatus();
  @State() isTransitioning: boolean = false;
  private unsubscribe: () => void = () => { };
  private previousStatus: LoadingBarStatus | null = null;

  componentWillLoad() {
    this.unsubscribe = loadingBarService.subscribeToStatus((status) => {
      if(this.status === status) return;

      this.previousStatus = this.status;
      this.status = status;
      this.isTransitioning = this.previousStatus !== null;
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  private shouldShowBar(): boolean {
    return this.status !== 'idle' || (this.isTransitioning && this.previousStatus !== 'idle');
  }

  private getAnimation(): string {
    if (!this.isTransitioning) return '';

    if (this.status === 'idle' && this.previousStatus !== 'idle') {
      return 'animate-fade-out';
    }

    switch (this.status) {
      case 'error':
      case 'done':
      case 'pending':
        return 'animate-fade-in-grow';
      case 'loading':
        return 'animate-loading-bar';
      default:
        return '';
    }
  }

  render() {
    if (!this.shouldShowBar()) {
      return <Host class="top-0 right-0 left-0 absolute"></Host>;
    }

    const getStatusColor = () => {
      switch (this.status) {
        case 'error': return 'bg-red-400';
        case 'done': return 'bg-green-400';
        case 'idle': return 'bg-green-400';
        case 'loading': return 'bg-blue-400';
        case 'pending': return 'bg-orange-300';
        default: return 'bg-gray-300';
      }
    };

    return (
      <Host class="top-0 right-0 left-0 absolute">
        <div class={`h-1 w-full ${this.status === 'idle' ? '' : 'bg-gray-300'} overflow-hidden`}>
          <div class={`h-1 w-full ${getStatusColor()} ${this.getAnimation()}`}></div>
        </div>
      </Host>
    );
  }
}
